import { render } from "./Syainlist.vue?vue&type=template&id=238208bf&ts=true"
import script from "./Syainlist.vue?vue&type=script&lang=ts"
export * from "./Syainlist.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__